import React, { type FunctionComponent, Fragment } from 'react'
import { type DashRouteComponentProps } from '@retailer-platform/dashboard/routing'
import { DocumentTitle, SelectionManagerProvider } from '@retailer-platform/dashboard/gin-and-tonic'
import { TDSStylesProvider } from '@retailer-platform/shared-components/src/tds'
import { Breadcrumb, Breadcrumbs, PageHeader } from '@retailer-platform/shared-components'
import { InstacartManagedReportsList } from '../../components/normalized-reports-list/InstacartManagedReportsList'
import { type ReportTypeConfig } from '../../components/normalized-reports-list/utils/ReportsNormalizedReportsList.utils'
import { ReportTypeEnum } from '../../api'
import { useDomainMessages } from '../../utils/domain/intl'

interface Props
  extends DashRouteComponentProps<{
    /*
    Add here any properties that you expect to come from the route. For instance,

    id: string
  */
    partner_id: string
    warehouse_id: string
  }> {}

const TransactionLogsListPage: FunctionComponent<React.PropsWithChildren<Props>> = ({ match }) => {
  const partnerId = match?.params?.partner_id
  const retailerId = match?.params?.warehouse_id

  const messages = useDomainMessages({
    analytics: 'reportsDomain.breadcrumbs.analytics.root',
    transactionLogs: 'reportsDomain.transactionLogsList.nav',
  })

  const reportTypesConfig: ReportTypeConfig = {
    [ReportTypeEnum.TransactionLogs]:
      'reportsDomain.normalizedReports.list.reportTypes.TRANSACTION_LOGS',
    [ReportTypeEnum.MergedTransactionLogs]:
      'reportsDomain.normalizedReports.list.reportTypes.TRANSACTION_LOGS_MERGED',
    [ReportTypeEnum.InStoreTransactions]:
      'reportsDomain.normalizedReports.list.reportTypes.IN_STORE_TRANSACTIONS',
    [ReportTypeEnum.MergedInStoreTransactions]:
      'reportsDomain.normalizedReports.list.reportTypes.IN_STORE_TRANSACTIONS_MERGED',
  }

  return (
    <TDSStylesProvider>
      <DocumentTitle titleId="reportsDomain.normalizedReports.list.pageTitle" />
      <PageHeader
        title={
          <div>
            <Breadcrumbs>
              <Breadcrumb>{messages.analytics}</Breadcrumb>
              <Breadcrumb>{messages.transactionLogs}</Breadcrumb>
            </Breadcrumbs>
          </div>
        }
      />

      <SelectionManagerProvider>
        <InstacartManagedReportsList
          partnerId={partnerId}
          retailerId={retailerId}
          reportTypesConfig={reportTypesConfig}
          filterUnavailableReportTypes={false}
        />
      </SelectionManagerProvider>
    </TDSStylesProvider>
  )
}

export default TransactionLogsListPage
